import axios from "axios";
import React, { useState, useEffect } from "react";
import { useAuth } from "../../src/Context/AuthContext";

const CompetenciesScore = ({ selectedEmployee }) => {
  const [attendanceSummary, setAttendanceSummary] = useState([]);
  const [shortLeave, setShortLeave] = useState(0);
  const [attendanceDetails, setAttendanceDetails] = useState([]);
  const [lateOccasions, setLateOccasions] = useState(0);
  const [extraHours, setExtraHours] = useState(0);
  const [careerDevelopment, setCareerDevelopment] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [careerDevScores, setCareerDevScores] = useState({});
  const { request_token } = useAuth();
  const [competenciesDetails, setCompetenciesDetails] = useState([]);
  const [careerDevPlans, setCareerDevPlans] = useState([]);

  const getServiceNo = () => {
    const serviceNo = localStorage.getItem("serviceNo");
    if (serviceNo) {
      return serviceNo;
    }

    return localStorage.getItem("username");
  };

  const [scores, setScores] = useState({
    superiorScores: {
      achievementOrientation: 0,
      peopleOrientation: 0,
      managerialOrientation: 0,
      adaptiveOrientation: 0,
    },
    selfScores: {
      achievementOrientation: 0,
      peopleOrientation: 0,
      managerialOrientation: 0,
      adaptiveOrientation: 0,
    },
    self1Scores: {
      achievementOrientation: 0,
      peopleOrientation: 0,
      managerialOrientation: 0,
      adaptiveOrientation: 0,
    },
  });


  useEffect(() => {
    const fetchSelf1Scores = async () => {
      try {
        const username = localStorage.getItem("username");
        const userType = localStorage.getItem("userType") || "Ex";
        const year = localStorage.getItem("year");
        const period = localStorage.getItem("period");

        if (!username || !year || !period) {
          console.warn(
            "Missing required data in local storage for self1. Skipping API call."
          );
          return;
        }

        const self1Response = await axios.get(
          "https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetCompetenciesDetails",
          {
            params: {
              serviceNo: username,
              UserType: userType,
              period,
              year,
              status: "S",
            },
            headers: { request_token },
          }
        );

        const self1Result = self1Response.data.ResultSet || [];


        const self1AchievementOrientation = self1Result
          .filter((item) => item.Com_Code >= 1 && item.Com_Code <= 6)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);

        const self1PeopleOrientation = self1Result
          .filter((item) => item.Com_Code >= 7 && item.Com_Code <= 11)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);

        const self1ManagerialOrientation = self1Result
          .filter((item) => item.Com_Code >= 12 && item.Com_Code <= 17)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);

        const self1AdaptiveOrientation = self1Result
          .filter((item) => item.Com_Code >= 18 && item.Com_Code <= 20)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);


        setScores((prevScores) => ({
          ...prevScores,
          self1Scores: {
            achievementOrientation: self1AchievementOrientation,
            peopleOrientation: self1PeopleOrientation,
            managerialOrientation: self1ManagerialOrientation,
            adaptiveOrientation: self1AdaptiveOrientation,
          },
        }));
      } catch (error) {
        console.error("Error fetching self1 competencies details:", error);
      }
    };

    fetchSelf1Scores();
  }, [request_token]);

  useEffect(() => {
    const fetchAttendanceSummary = async () => {
      try {
        const serviceNo = getServiceNo();
        const year = localStorage.getItem("year");
        const periodType = localStorage.getItem("period") || "defaultPeriod";
        const userType = localStorage.getItem("userType") || "Ex";

        if (!serviceNo || !year) {
          console.warn(
            "Missing required data in local storage. Skipping API call."
          );
          setIsLoading(false);
          return;
        }

        const response = await axios.get(
          "/Evaluation/GetAttendanceSummaryData",
          {
            params: {
              serviceNo,
              year: parseInt(year, 10),
              periodType,
              UserType: userType,
            },
            headers: { request_token },
          }
        );

        const result = response.data.ResultSet;
        setShortLeave(parseInt(result.Short_leave, 10) || 0);
        setAttendanceDetails(result.AttendanceSummaryDataGrid2);
        setAttendanceSummary(result.AttendanceSummaryDataGrid1);
        setLateOccasions(result.Late_occassions);
        setExtraHours(result.Extra_Hours_Performed);
      } catch (error) {
        console.error("Error fetching attendance summary data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchCompetenciesDetails = async () => {
      try {
        const serviceNo = getServiceNo();
        const year = localStorage.getItem("year");
        const period = localStorage.getItem("period");
        const userType = localStorage.getItem("userType") || "Ex";

        if (!serviceNo || !year) {
          console.warn(
            "Missing required data in local storage. Skipping API call."
          );
          setIsLoading(false);
          return;
        }


        const superiorResponse = await axios.get(
          "https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetCompetenciesDetails",
          {
            params: {
              serviceNo,
              UserType: userType,
              period,
              year,
              status: "D",
            },
            headers: { request_token },
          }
        );


        const selfResponse = await axios.get(
          "https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetCompetenciesDetails",
          {
            params: {
              serviceNo,
              UserType: userType,
              period,
              year,
              status: "S",
            },
            headers: { request_token },
          }
        );

        const superiorResult = superiorResponse.data.ResultSet || [];
        const selfResult = selfResponse.data.ResultSet || [];

        setCompetenciesDetails([...superiorResult, ...selfResult]);


        const superiorAchievementOrientation = superiorResult
          .filter((item) => item.Com_Code >= 1 && item.Com_Code <= 6)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);

        const superiorPeopleOrientation = superiorResult
          .filter((item) => item.Com_Code >= 7 && item.Com_Code <= 11)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);

        const superiorManagerialOrientation = superiorResult
          .filter((item) => item.Com_Code >= 12 && item.Com_Code <= 17)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);

        const superiorAdaptiveOrientation = superiorResult
          .filter((item) => item.Com_Code >= 18 && item.Com_Code <= 20)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);


        const selfAchievementOrientation = selfResult
          .filter((item) => item.Com_Code >= 1 && item.Com_Code <= 6)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);

        const selfPeopleOrientation = selfResult
          .filter((item) => item.Com_Code >= 7 && item.Com_Code <= 11)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);

        const selfManagerialOrientation = selfResult
          .filter((item) => item.Com_Code >= 12 && item.Com_Code <= 17)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);

        const selfAdaptiveOrientation = selfResult
          .filter((item) => item.Com_Code >= 18 && item.Com_Code <= 20)
          .reduce((sum, item) => sum + parseInt(item.Com_Score, 10), 0);


        setScores((prevScores) => ({
          ...prevScores,
          superiorScores: {
            achievementOrientation: superiorAchievementOrientation,
            peopleOrientation: superiorPeopleOrientation,
            managerialOrientation: superiorManagerialOrientation,
            adaptiveOrientation: superiorAdaptiveOrientation,
          },
          selfScores: {
            achievementOrientation: selfAchievementOrientation,
            peopleOrientation: selfPeopleOrientation,
            managerialOrientation: selfManagerialOrientation,
            adaptiveOrientation: selfAdaptiveOrientation,
          },
        }));
      } catch (error) {
        console.error("Error fetching competencies details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchCareerDevelopmentScores = async () => {
      try {
        const serviceNo = getServiceNo();

        const userType = localStorage.getItem("userType") || "Ex";
        const year = localStorage.getItem("year");
        const period = localStorage.getItem("period") || "defaultPeriod";

        if (!serviceNo) {
          console.warn("Missing required data in local storage.");
          return;
        }

        const response = await axios.get(
          "https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetCareerDev",
          {
            params: { serviceNo, UserType: userType, year, period },
            headers: { request_token },
          }
        );

        const result = response.data.ResultSet || [];

        const scoresMap = {};
        const plansArray = [];

        result.forEach((item) => {
          scoresMap[item.Care_area] = item.Care_Score;
          plansArray.push({
            Care_ID: item.Care_area,
            area: getCareAreaTitle(item.Care_area),
            plan: item.Care_Plan,
          });
        });

        setCareerDevScores(scoresMap);
        setCareerDevPlans(plansArray);
      } catch (error) {
        console.error("Error fetching career development data:", error);
      }
    };

    const getCareAreaTitle = (careArea) => {
      const titles = {
        1: "Professional Qualifications",
        2: "Higher Education",
        3: "Continuous Professional Development - CPD",
      };
      return titles[careArea] || `Area ${careArea}`;
    };

    fetchCareerDevelopmentScores();
    fetchAttendanceSummary();
    fetchCompetenciesDetails();
  }, [selectedEmployee, request_token]);

  return (
    <div className="bg-white shadow p-4 rounded">
      <h3 className="text-lg font-semibold text-gray-700 mb-4">
        Competencies Score
      </h3>
      <div className="overflow-x-auto">
        <table className="table-auto w-full border">
          <thead>
            <tr className="bg-gray-100 text-left">
              <th className="p-2 border">Criteria</th>
              <th className="p-2 border">Superior Appraisal</th>
              <th className="p-2 border">Self Appraisal</th>
              {/* <th className="p-2 border text-center">Self Evaluation </th> */}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-2 border">
                Achievement Orientation <span className="font-bold">(30)</span>
              </td>
              <td className="p-2 border text-left">
                {scores.superiorScores.achievementOrientation}
              </td>
              <td className="p-2 border text-left">
                {scores.selfScores.achievementOrientation}
              </td>
              {/* <td className="p-2 border text-center bg-indigo-50">{scores.self1Scores.achievementOrientation}</td> */}
            </tr>
            <tr>
              <td className="p-2 border">
                People Orientation <span className="font-bold">(25)</span>
              </td>
              <td className="p-2 border text-left">
                {scores.superiorScores.peopleOrientation}
              </td>
              <td className="p-2 border text-left">
                {scores.selfScores.peopleOrientation}
              </td>
              {/* <td className="p-2 border text-center bg-indigo-50">{scores.self1Scores.peopleOrientation}</td> */}
            </tr>
            <tr>
              <td className="p-2 border">
                Managerial Orientation <span className="font-bold">(30)</span>
              </td>
              <td className="p-2 border text-left">
                {scores.superiorScores.managerialOrientation}
              </td>
              <td className="p-2 border text-left">
                {scores.selfScores.managerialOrientation}
              </td>
              {/* <td className="p-2 border text-center bg-indigo-50">{scores.self1Scores.managerialOrientation}</td> */}
            </tr>
            <tr>
              <td className="p-2 border">
                Adaptive Orientation <span className="font-bold">(15)</span>
              </td>
              <td className="p-2 border text-left">
                {scores.superiorScores.adaptiveOrientation}
              </td>
              <td className="p-2 border text-left">
                {scores.selfScores.adaptiveOrientation}
              </td>
              {/* <td className="p-2 border text-center bg-indigo-50" >{scores.self1Scores.adaptiveOrientation}</td> */}
            </tr>
            <tr className="bg-gray-200 text-left">
              <td className="p-2 border font-bold">Total</td>
              <td className="bg-yellow-300 p-2 border font-bold text-left">
                {Object.values(scores.superiorScores).reduce(
                  (sum, score) => sum + score,
                  0
                )}
              </td>
              <td className=" bg-yellow-300 p-2 border font-bold text-left">
                {Object.values(scores.selfScores).reduce(
                  (sum, score) => sum + score,
                  0
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="my-4 border-t border-gray-300" />

      <h3 className="text-lg font-semibold text-gray-700 mb-4">
        Career Development Score
      </h3>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300 text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left">
                Area
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left">
                Plan
              </th>
              <th className="border border-gray-300 px-4 py-2 text-center">
                Score
              </th>
            </tr>
          </thead>
          <tbody>
            {careerDevPlans.map((item, index) => (
              <tr
                key={index}
                className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                <td className="border border-gray-300 px-4 py-2">
                  {item.area}
                </td>
                <td
                  className="border border-gray-300 px-4 py-2"
                  style={{ backgroundColor: "#fdf2e9" }}
                >
                  {item.plan}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  {careerDevScores[item.Care_ID] ?? 0}
                </td>
              </tr>
            ))}
            <tr>
              <td
                className="border border-gray-300 px-4 py-2 font-semibold"
                colSpan={2}
              >
                Total
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center bg-yellow-300 font-semibold">
                {Object.values(careerDevScores).reduce(
                  (sum, score) => sum + parseInt(score || 0, 10),
                  0
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="my-4 border-t border-gray-300" />

      <h3 className="text-lg font-semibold text-gray-700 mb-4">
        HR Aspects Score
      </h3>
      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="border px-4 py-2 text-left">Description</th>
              <th className="border px-4 py-2 text-center">Total</th>
              <th className="border px-4 py-2 text-center">Taken</th>
              <th className="border px-4 py-2 text-center"> (%)</th>
            </tr>
          </thead>
          <tbody>
            {attendanceSummary.map((item, index) => {
              const total = parseFloat(item.Total) || 0;
              const taken = parseFloat(item.Taken) || 0;
              const balancePercentage =
                total > 0 ? ((taken / total) * 100).toFixed(2) : "0.00";

              return (
                <tr key={index}>
                  <td className="border px-4 py-2">{item.Description}</td>
                  <td className="border px-4 py-2 text-center">{total}</td>
                  <td className="border px-4 py-2 text-center">{taken}</td>
                  <td className="border px-4 py-2 text-center">
                    {balancePercentage}%
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="my-4 border-t border-gray-300" />

      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="border px-4 py-2 text-left"></th>
              <th className="border px-4 py-2 text-left">Total</th>
              <th className="border px-4 py-2 text-center">Taken</th>
              <th className="border px-4 py-2 text-center">%</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2">Short Leave Taken</td>
              <td className="border px-4 py-2 text-center">24</td>
              <td className="border px-4 py-2 text-center">{shortLeave}</td>
              <td className="border px-4 py-2 text-center">
                {24 > 0 ? ((shortLeave / 24) * 100).toFixed(2) : "0.00"}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="my-4 border-t border-gray-300" />

      <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8">
        <div className="overflow-x-auto w-full md:w-1/3">
          <table className="table-auto w-full border">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="p-2 border">Leave Type</th>
                <th className="p-2 border">Days</th>
              </tr>
            </thead>
            <tbody>
              {attendanceDetails.map((item, index) => (
                <tr key={index}>
                  <td className="border px-4 py-2">{item.LeaveType}</td>
                  <td className="border px-4 py-2 text-center">
                    {item.Days || 0}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="overflow-x-auto w-full md:w-1/3">
          <table className="table-auto w-full border">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="p-2 border"></th>
                <th className="p-2 border">Days</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border px-4 py-2">Late Occasions</td>
                <td className="border px-4 py-2 text-center">
                  {lateOccasions}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="overflow-x-auto w-full md:w-1/3">
          <table className="table-auto w-full border">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="p-2 border"></th>
                <th className="p-2 border">%</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border px-4 py-2">Extra Hours Performed</td>
                <td className="border px-4 py-2 text-center">
                  {500 > 0 ? ((extraHours / 2080) * 100).toFixed(2) : "0.00"}%
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CompetenciesScore;
